import { getPushStreamToken, getStreamToken } from "@api/streamdata";
import { SrsRtcPublisherAsync } from "@utils/rtc";
import { srsRtcUrl } from "@utils/basic";
import { askPermission } from "@api/permission";
import { showWindowMessage } from "@utils/notification";
import { getTencentAuthentication } from "@api/record";

export default {
  data() {
    return {
      recognitionText: []
    };
  },
  methods: {
    getCurrentTime() {
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      return `${hours}:${minutes}`;
    },
    // 如果护士没有权限,则去请求权限
    async getPermissionForLive() {
      try {
        this.askPermissionForm = {
          type: "checkLive",
          hospitalId: this.hospitalID,
          ambulanceId: this.carID,
          medicalhistoryId: this.patientSituation.id,
          userId: this.userInfo.id
        };
        const { code, msg } = await askPermission(this.askPermissionForm);
        this.infoDialogMessage = msg;
        if (code === 200) {
          this.infoDialog = true;
        } else {
          this.infoDialog = true;
        }
      } catch (e) {
        showWindowMessage(3, e, this);
      }
    },
    /**
     *  推流麦克风
     * */
    async startPushAudio() {
      try {
        const { code, token, car_number, audio_can } = await getPushStreamToken(this.carID);
        if (code !== 200) return;
        if (audio_can !== 1) {
          this.isOpenMic = false;
          alert("麦克风只能同时被一个用户使用, 当前有其他用户正在使用, 不允许使用, 请稍后再试!");
          return;
        }
        this.publisher = new SrsRtcPublisherAsync();
        const url = srsRtcUrl + `${car_number}/${car_number}-audio?token=${token}`;
        this.publisher.publish(url)
          .then(() => {
            console.log("推麦克风成功");
          })
          .catch(e => {
            showWindowMessage(3, e, this);
          });
      } catch (e) {
        showWindowMessage(3, e, this);
      }
    },
    // 拉取webrtc视频流 || 进来的时候 (两个都拉)
    async getStreamInfo() {
      // 判断是否有打开麦克风, 有的话, 也要重新连接
      if (this.isOpenMic) {
        this.publisher && this.publisher.close();
        await this.startPushAudio();
      }
      try {
        // "ecg": 1, // 0代表无人车/机没有心电图视频，1代表有心电图视频，2代表心电图视频没有在推
        // "live": 0, // 0代表没有权限，1代表有权限可以播放，2代表监控视频没有在推
        const { code, data, status } = await getStreamToken(this.carID);
        if (code === 200) {
          const { live } = status;
          if (live === 0) {
            this.hasPermission = false;
            this.hasVideo = true;
          } else if (live === 1) {
            const type1 = data.find(e => {
              return e.type === 1;
            });
            if (type1) {
              this.hasPermission = true;
              this.hasVideo = true;
              this.videoType1 = srsRtcUrl + `${type1.app}/${type1.stream}?token=${type1.token}&time=${Date.now()}`; // 摄像头和麦克风
            }
          } else {
            this.hasPermission = true;
            this.hasVideo = false;
          }
          const type2 = data.find(e => {
            return e.type === 2;
          });

          if (type2) {
            this.videoType2 = srsRtcUrl + `${type2.app}/${type2.stream}?token=${type2.token}&time=${Date.now()}`; // 救护仪器
          }
        } else {
          this.hasPermission = true;
          this.hasVideo = false;
          this.videoType1 = srsRtcUrl + "";
          this.videoType2 = srsRtcUrl + "";
        }
      } catch (e) {
        showWindowMessage(3, e, this);
      }
    },
    // 拉取监护仪
    async getStreamInfo1() {
      // 判断是否有打开麦克风, 有的话, 也要重新连接
      const { code, data } = await getStreamToken(this.carID);
      if (code === 200 || code === 405) {
        const type2 = data.find(e => {
          return e.type === 2;
        });
        if (type2) {
          this.videoType2 = srsRtcUrl + `${type2.app}/${type2.stream}?token=${type2.token}&time=${Date.now()}`; // 救护仪器
        }
      } else {
        this.videoType2 = srsRtcUrl + "";
      }
    },
    // 拉取监控
    async getStreamInfo2() {
      // 判断是否有打开麦克风, 有的话, 也要重新连接
      if (this.isOpenMic) {
        this.publisher && this.publisher.close();
        await this.startPushAudio();
      }
      try {
        const { code, data } = await getStreamToken(this.carID);
        if (code === 200 || code === 405) {
          const type1 = data.find(e => {
            return e.type === 1;
          });
          if (type1) {
            this.hasPermission = true;
            this.videoType1 = srsRtcUrl + `${type1.app}/${type1.stream}?token=${type1.token}&time=${Date.now()}`; // 摄像头和麦克风
          }
        } else {
          this.videoType1 = srsRtcUrl + "";
        }
      } catch (e) {
        showWindowMessage(3, e, this);
      }
    },
    /* 准备调用腾讯接口，语音识别 */
    async startAudioRecognition(stream) {
      const { code, data, msg, appId } = await getTencentAuthentication();
      if (code !== 200) {
        showWindowMessage(3, msg, this);
        return;
      }
      const { TmpSecretId, TmpSecretKey, Token } = data.Credentials;
      try {
        await this.startRecognitionWork(TmpSecretId, TmpSecretKey, Token, appId, stream);
      } catch (e) {
        showWindowMessage(3, e, this);
        console.log(stream);
      }
    },
    startRecognitionWork(TmpSecretId, TmpSecretKey, Token, appId, stream) {
      console.log(stream.getAudioTrack());
      const options = {
        secretKey: TmpSecretKey,
        secretId: TmpSecretId,
        token: Token,
        appId: appId,
        // 实时识别接口参数
        engine_model_type: "16k_zh", // 引擎
        voice_format: 1,
        // 以下为非必填参数，可跟据业务自行修改
        hotword_id: "08003a00000000000000000000000000",
        needvad: 1,
        filter_dirty: 1,
        filter_modal: 1,
        filter_punc: 1,
        convert_num_mode: 1,
        word_info: 2,
        audioTrack: stream.getAudioTrack(),
      };
      const localStreamAsr = new ASR(options);
      // 开始语音识别调用
      localStreamAsr.start();
      // 开始识别
      localStreamAsr.OnRecognitionStart = (res) => {
        console.log("本地流：开始识别", res);
      };
      // 一句话开始
      localStreamAsr.OnSentenceBegin = (res) => {
        console.log("本地流：一句话开始", res);
      };
      // 识别变化时
      localStreamAsr.OnRecognitionResultChange = (res) => {
        console.log("本地流：识别变化时", res);
      };
      // 一句话结束
      localStreamAsr.OnSentenceEnd = (res) => {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, "0");
        const minutes = String(now.getMinutes()).padStart(2, "0");
        const time = `${hours}:${minutes}`;
        const { voice_id, voice_text_str } = res;
        const data = {
          id: voice_id,
          time: time,
          text: voice_text_str,
          speaker: this.allUsers.find(user => {
            return user.id === stream.getUserId();
          })?.name || "未知用户"
        };
        this.recognitionText.push(data);
        console.log("本地流：一句话结束", res);
      };
      // 识别有结果时
      localStreamAsr.OnChange = (res) => {
        console.log("本地流：识别中", res);
      };
      // 识别结束
      localStreamAsr.OnRecognitionComplete = (res) => {
        console.log("本地流：识别结束", res);
      };
      // 识别错误
      localStreamAsr.OnError = (res) => {
        console.log("本地流：识别失败", res);
        const time = this.getCurrentTime();
        const data = {
          id: -1,
          time: time,
          text: res,
          speaker: ""
        };
        this.recognitionText.push(data);
        // 关闭识别时
        localStreamAsr?.stop();
      };
    }
  }
};
